import type { ReactElement } from 'react';
import { cloneElement } from 'react';

interface FeatureCardProps {
  icon: ReactElement<{ className?: string }>;
  title: string;
  description: string;
}

export default function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <div className="group p-6 rounded-2xl border border-slate-200 bg-white/50 hover:border-emerald-200/60 hover:bg-emerald-50/30 hover:shadow-md transition-all duration-300">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0 w-14 h-14 rounded-xl flex items-center justify-center bg-gradient-to-br from-emerald-100 to-green-100 group-hover:from-emerald-200 group-hover:to-green-200 transition-all duration-300">
          {cloneElement(icon, { className: 'h-6 w-6 text-emerald-600' })}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold mb-2 text-slate-800 group-hover:text-slate-900 transition-colors">
            {title}
          </h3>
          <p className="text-sm leading-relaxed text-slate-500 group-hover:text-slate-600 transition-colors">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
